<template>
  <div>
    <vx-card>
      <ValidationObserver v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent="handleSubmit">
          <vs-divider position="center">{{ $t('sections.customer.section.personalInformation') }}</vs-divider>
          <div class="vx-row flex flex-wrap">
            <!-- Prefix -->
            <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.prefix')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.prefix') }}*</label>
                <v-select :clearable="true" :options="prefixOptions" :name="$t('sections.customer.dataForm.prefix')" :reduce="res => res.value" v-model="form.prefix"  :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <!-- Name -->
            <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-2/5">
              <validation-provider :name="$t('sections.customer.dataForm.name')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.customer.dataForm.name") }}*</label>
                <vs-input type="text" class="w-full" v-model="form.name"  :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <!-- Surname -->
            <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-2/5">
              <validation-provider :name="$t('sections.customer.dataForm.surname')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{$t('sections.customer.dataForm.surname')}}*</label>
                <vs-input type="text" class="w-full" v-model="form.surname"  :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex flex-wrap">
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.birthDay')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.birthDay') }}</label>
                <flat-pickr :config="configDatePicker" class="w-full" v-model="form.birthDay"  :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 ">
              <validation-provider :name="$t('sections.customer.dataForm.idCardNumber')" rules="required|numberOnly" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.idCardNumber') }}*</label>
                <vs-input type="text" class="w-full"  v-model="form.idCardNumber"  :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 ">
              <validation-provider :name="$t('sections.customer.dataForm.issueDate')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.issueDate') }}</label>
                <flat-pickr :config="configDatePicker" class="w-full" v-model="form.issueDate"  :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 ">
              <validation-provider :name="$t('sections.customer.dataForm.expDate')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.expDate') }}</label>
                <flat-pickr :config="configDatePicker" class="w-full" v-model="form.expDate"  :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex flex-wrap">
            <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3">
              <validation-provider :name="$t('sections.customer.dataForm.occupation')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.occupation') }}</label>
                <vs-input type="text" v-model="form.career" class="w-full"  :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3">
              <validation-provider :name="$t('sections.customer.dataForm.position')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.position') }}</label>
                <vs-input type="text" v-model="form.position" class="w-full"  :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3">
              <validation-provider :name="$t('sections.customer.dataForm.affiliate')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.affiliate') }}</label>
                <vs-input type="text" v-model="form.affiliate" class="w-full"  :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>

          <div class="vx-row flex flex-wrap">
            <div class="vx-col w-full  md:w-1/2 lg:w-1/2">
              <validation-provider :name="$t('sections.customer.dataForm.project')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.project') }}*</label>
                <v-select v-model="form.project" :clearable="true" :options="projectOptions" :name="$t('sections.customer.dataForm.project')" :reduce="res => res.value"   :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full  md:w-1/2 lg:w-1/2">
              <validation-provider :name="$t('sections.customer.dataForm.studentCode')" rules="required|numberOnly" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.studentCode') }}*</label>
                <vs-input type="text" v-model="form.studentCode" class="w-full"   :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex flex-wrap ">
            <div class="vx-col w-full sm:w-1/2 md:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.degree')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.degree') }}*</label>
                <v-select v-model="form.degree" :clearable="true" :options="degreeOptions" :name="$t('sections.customer.dataForm.degree')" :reduce="res => res.value"  :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col  w-full sm:w-1/2 md:w-1/4">
              <validation-provider name="ปีการศึกษา" rules="required|periodTermYear" v-slot="{ errors }">
                <label class="vs-input--label">ปีการศึกษา*</label>
                <vs-input type="text" v-model="form.period" class="w-full"   :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full md:w-1/2">
              <validation-provider :name="$t('sections.customer.dataForm.curriculum')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.faculty') }}/{{ $t('sections.customer.dataForm.curriculum') }}*</label>
                <v-select v-model="form.curriculum" :clearable="true" :options="facultyCurriculumOptions" :name="$t('sections.customer.dataForm.curriculum')" :reduce="res => res.value"   :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <vs-divider position="center">{{ $t('sections.customer.section.contactInformation') }}</vs-divider>
          <div class="vx-row flex flex-wrap">
            <div class="vx-col w-full  sm:w-1/2 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.location')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.location') }}</label>
                <vs-input type="text" v-model="form.address.location" class="w-full"   :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full  sm:w-1/2 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.houseNumber')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.houseNumber') }}</label>
                <vs-input type="text" v-model="form.address.houseNumber" class="w-full"   :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full  sm:w-1/3 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.moo')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.moo') }}</label>
                <vs-input type="text" v-model="form.address.moo" class="w-full"   :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full  sm:w-1/3 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.alley')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.alley') }}</label>
                <vs-input type="text" v-model="form.address.alley" class="w-full"   :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full  sm:w-1/3 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.road')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.road') }}</label>
                <vs-input type="text" v-model="form.address.road" class="w-full"   :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex flex-wrap">
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.subDistrict')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.subDistrict') }}</label>
                <addressinput-subdistrict :store="store" v-model="form.address.subDistrict" label="" class="w-full"   :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.district')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.district') }}</label>
                <addressinput-district :store="store" v-model="form.address.district" label="" class="w-full"   :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.province')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.province') }}</label>
                <addressinput-province :store="store" v-model="form.address.province" label="" class="w-full"   :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.zipcode')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.zipcode') }}</label>
                <addressinput-zipcode :store="store" v-model="form.address.zipcode" label="" class="w-full"   :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex flex-wrap">
            <div class="vx-col w-full  sm:w-1/2 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.locationDoc')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.locationDoc') }}</label>
                <vs-input type="text" v-model="form.address.locationDoc" class="w-full"   :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full  sm:w-1/2 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.houseNumber')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.houseNumber') }}</label>
                <vs-input type="text" v-model="form.address.houseNumberDoc" class="w-full"   :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full  sm:w-1/3 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.moo')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.moo') }}</label>
                <vs-input type="text" v-model="form.address.mooDoc" class="w-full"   :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full  sm:w-1/3 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.alley')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.alley') }}</label>
                <vs-input type="text" v-model="form.address.alleyDoc" class="w-full"   :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full  sm:w-1/3 lg:w-1/5">
              <validation-provider :name="$t('sections.customer.dataForm.road')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.road') }}</label>
                <vs-input type="text" v-model="form.address.roadDoc" class="w-full"   :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex flex-wrap">
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.subDistrict')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.subDistrict') }}</label>
                <addressinput-subdistrict :store="storeDoc" v-model="form.address.subDistrictDoc" label="" class="w-full"   :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.district')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.district') }}</label>
                <addressinput-district :store="storeDoc" v-model="form.address.districtDoc" label="" class="w-full"   :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.province')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.province') }}</label>
                <addressinput-province :store="storeDoc" v-model="form.address.provinceDoc" label="" class="w-full"   :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4">
              <validation-provider :name="$t('sections.customer.dataForm.zipcode')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.zipcode') }}</label>
                <addressinput-zipcode :store="storeDoc" v-model="form.address.zipcodeDoc" label="" class="w-full"   :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row flex flex-wrap">
            <div class="vx-col  w-full  sm:w-1/3">
              <validation-provider :name="$t('sections.customer.dataForm.phone')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.phone') }}</label>
                <vs-input type="text" v-model="form.phone" class="w-full"   :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col  w-full  sm:w-1/3">
              <validation-provider :name="$t('sections.customer.dataForm.mobile')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.mobile') }}*</label>
                <vs-input type="text" v-model="form.mobile" class="w-full"   :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col  w-full  sm:w-1/3">
              <validation-provider :name="$t('sections.customer.dataForm.email')" rules="required|email" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.customer.dataForm.email') }}*</label>
                <vs-input type="text" v-model="form.email" class="w-full"   :disabled="true" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { ValidationProvider } from 'vee-validate'
import { createNamespacedHelpers, mapGetters } from 'vuex'
import flatPickr from 'vue-flatpickr-component'
import { Thai } from 'flatpickr/dist/l10n/th'
import 'flatpickr/dist/themes/dark.css';
import { DataStore } from 'vue-thailand-address';

const {mapActions: mapCustomerActions, mapState: mapCustomerFields } = createNamespacedHelpers('Customer')
const {mapActions: mapMasterActions } = createNamespacedHelpers('Master')

export default {
  components: {
    vSelect,
    ValidationProvider,
    flatPickr
  },
  data () {
    return {
      form:{
        prefix: '',
        name: '',
        surname: '',
        birthDay: '',
        idCardNumber: '',
        issueDate: '',
        expDate: '',
        career: '',
        position: '',
        affiliate: '',
        studentCode: '',
        project: '',
        degree: '',
        period: '',
        periodTerm: '',
        periodYear: 0,
        curriculum: '',
        address: {
          id: '',
          location: '',
          houseNumber: '',
          moo: '',
          alley: '',
          road: '',
          subDistrict: '',
          district: '',
          province: '',
          zipcode: '',
          locationDoc: '',
          houseNumberDoc: '',
          mooDoc: '',
          alleyDoc: '',
          roadDoc: '',
          subDistrictDoc: '',
          districtDoc: '',
          provinceDoc: '',
          zipcodeDoc: ''
        },
        phone: '',
        mobile: '',
        email: '',
        status: 'Enabled'
      },
      configDatePicker: {
        monthSelectorType: "static",
        allowInput: true,
        locale: Thai,
        dateFormat: "d-m-Y"
      },
      store: new DataStore(),
      storeDoc: new DataStore(),
    }
  },
  computed: {
    ...mapCustomerFields(['status', 'borrower']),
    ...mapGetters({
      prefixOptions :'Master/prefixOptions',
      projectOptions :'Master/projectOptions',
      degreeOptions :'Master/degreeOptions',
      facultyCurriculumOptions :'Master/facultyCurriculumOptions',
      statusesOptions :'Master/statusesOptions',
    })
  },
  methods: {
    ...mapCustomerActions(['initializing', 'getBorrower', 'updateBorrower']),
    ...mapMasterActions(['getPrefixOptions', 'getProjectOptions', 'getDegreeOptions', 'getCurriculumOptions']),
    async loadOptions() {
      const vm = this
      const { getPrefixOptions, getProjectOptions, getDegreeOptions, getCurriculumOptions } = vm
      if(vm.prefixOptions.length === 0) await getPrefixOptions()
      if(vm.projectOptions.length === 0) await getProjectOptions()
      if(vm.degreeOptions.length === 0) await getDegreeOptions()
      if(vm.facultyCurriculumOptions.length === 0) await getCurriculumOptions()
    },
    async initData() {
      const vm = this;
      const { getBorrower } = vm
      await getBorrower({form: {id: vm.$route.params.id}})
      const { borrower } = vm
      const prefix = (borrower.prefix ? borrower.prefix.id : '')
      const project = (borrower.project ? borrower.project.id : '')
      const degree = (borrower.degree ? borrower.degree.id : '')
      const curriculum = (borrower.curriculum ? borrower.curriculum.id : '')
      vm.form = {
        prefix,
        name: borrower.name,
        surname: borrower.surname,
        birthDay: vm.$options.filters.convYYYYMMDDToDDMMYYYY(borrower.birthDay),
        idCardNumber: borrower.idCardNumber,
        issueDate: vm.$options.filters.convYYYYMMDDToDDMMYYYY(borrower.issueDate),
        expDate: vm.$options.filters.convYYYYMMDDToDDMMYYYY(borrower.expDate),
        career: borrower.career,
        position: borrower.position,
        affiliate: borrower.affiliate,
        studentCode: borrower.studentCode,
        project,
        degree,
        period: `${borrower.periodTerm}/${borrower.periodYear}`,
        periodTerm: borrower.periodTerm,
        periodYear: borrower.periodYear,
        curriculum,
        address: {
          location: borrower.address.location,
          houseNumber: borrower.address.houseNumber,
          moo: borrower.address.moo,
          alley: borrower.address.alley,
          road: borrower.address.road,
          subDistrict: borrower.address.subDistrict,
          district: borrower.address.district,
          province: borrower.address.province,
          zipcode: borrower.address.zipcode,
          locationDoc: borrower.address.locationDoc,
          houseNumberDoc: borrower.address.houseNumberDoc,
          mooDoc: borrower.address.mooDoc,
          alleyDoc: borrower.address.alleyDoc,
          roadDoc: borrower.address.roadDoc,
          subDistrictDoc: borrower.address.subDistrictDoc,
          districtDoc: borrower.address.districtDoc,
          provinceDoc: borrower.address.provinceDoc,
          zipcodeDoc: borrower.address.zipcodeDoc
        },
        phone: borrower.phone,
        mobile: borrower.mobile,
        email: borrower.email,
        status: borrower.status
      }
    },
    reset () {
      const vm = this
      vm.initData();
    }
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  },
  async created() {
    const vm = this
    const {initializing} = vm
    initializing(true);
    await vm.loadOptions();
    await vm.initData();
    initializing(false);
  },
}
</script>

<style scoped>
.vx-col {
  padding-top: 10px;
}

</style>
